import axios from "axios";
import { APP_API_KEY, INSTANCE_URL } from "@constant";
import { getRequest, patchRequest } from "@network";
import { getHeaders } from "@commonutils";
import { fetchBalance, fetchConversionRate } from "@transactionaction";
import LocaleStrings from "@language";

export const ACTION_LOGIN = "ACTION_LOGIN";
export const ACTION_LOGOUT = "ACTION_LOGOUT";
export const RESET = "RESET";
export const SESSION_TOKEN = "SESSION_TOKEN";
export const UPDATE_USER_NAME = "UPDATE_USER_NAME";
export const TEACHER_CLASS_LISTS = "TEACHER_CLASS_LISTS";
export const TEACHER_STUDENT_LISTS = "TEACHER_STUDENT_LISTS";
export const ALL_STUDENT_LISTS = "ALL_STUDENT_LISTS";
export const ALL_CLASS_WITH_CHAPTER_LIST = "ALL_CLASS_WITH_CHAPTER_LIST";
export const ALL_CLASS_WITH_CHAPTER_AND_SET_LIST =
  "ALL_CLASS_WITH_CHAPTER_AND_SET_LIST";
export const GLOBAL_LEVELS = "GLOBAL_LEVELS";
export const EVENT = "EVENT";
export var LOCALE_LANGUAGE = "LOCALE_LANGUAGE";

export function checkEvent(session, seocode, callback) {
  //Live
  //seocode = "caris";
  //seocode = "carwashvanbrussel";
  //seocode = "prova";

  //Dev
  //seocode = "ownerportal";
  //seocode = "twash";

  var filter = encodeURI(`(seocode=${seocode})`);
  var url = `${INSTANCE_URL}/api/v2/tikwash/_table/appuser_additional_info?related=*&fields=useridfk,seocode,emaildomain,themecolor,companyname,api_key,tvanumber,companylogo,website&filter=(${filter})`;
  let newSession = {};
  newSession.apiKey = session.apiKey;

  // console.log('seocode checkEvent: ', seocode);

  return (dispatch) => {
    getRequest(
      url,
      newSession,
      dispatch,
      (data) => {
        //console.log('data :- ', data);
        if (data.resource && data.resource.length > 0) {
          // Set event theme color
          // var root = document.querySelector(':root');
          let root = document.documentElement;
          root.style.setProperty("--theme-color", data.resource[0].themecolor);

          dispatch({
            type: EVENT,
            payload: data.resource[0],
          });
          if (session && data.resource[0].useridfk) {
            dispatch(
              fetchBalance(session, data.resource[0].useridfk, (res) => {
                //callback({ success: 1, data: data.resource[0] });
              })
            );
            dispatch(fetchConversionRate(session, data.resource[0].useridfk));
          }

          callback({ success: 1, data: data.resource[0] });
        } else {
          callback({ success: 0 });
        }
      },
      (error) => {}
    );
  };
}

export function mainSigup(session, values, callback) {
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var data = { ...values };
  var url = `${INSTANCE_URL}/api/v2/signup`;
  var response = axios.post(url, data, config);

  return (dispatch) => {
    response
      .then(({ data }) => {
        // console.log("signup data :- ", data);

        if (data.iserror == 0) {
          session = {
            ...session,
            session_token: data.user.session_token,
            userid: data.user.userid,
            dfid: data.user.dfid,
            username: data?.user?.username,
            email: data.user.email,
            usertype: data.user.usertype,
          };

          dispatch({ type: ACTION_LOGIN, payload: true });
          dispatch({ type: SESSION_TOKEN, payload: session });

          setTimeout(() => {
            callback({ success: 1, response: data.user });
          }, 1000);
        } else {
          callback({ success: 2, response: data });
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function basicUpdates(session, values, callback) {
  var url = `${INSTANCE_URL}api/v2/memoryquiz/_table/users`;
  var body = { resource: [{ ...values }] };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: UPDATE_USER_NAME,
          payload: { username: values?.username },
        });
        callback({ success: 1, data: response });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function mainLogin(session, values, callback) {
  //This function is used on Login screen only
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var data = { ...values, duration: 0 };
  var url = `${INSTANCE_URL}api/v2/user/session`;
  var response = axios.post(url, data, config);

  return (dispatch) => {
    response
      .then(({ data }) => {
        //console.log("login data :- ", data);
        if (data?.usertype == "company") {
          //console.log("company");
          callback({ success: 2 });
        } else {
          //console.log("user");
          session = {
            ...session,
            session_token: data?.session_token,
            userid: data?.userid,
            dfid: data?.userid,
            username: data?.name,
            email: data?.email,
            usertype: data?.usertype,
          };

          dispatch({ type: ACTION_LOGIN, payload: true });
          dispatch({ type: SESSION_TOKEN, payload: session });

          setTimeout(() => {
            callback({ success: 1, response: data });
          }, 1000);
        }
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function logout(session) {
  var url = `${INSTANCE_URL}/api/v2/user/session`;
  var response = axios.delete(url, getHeaders(session));
  return (dispatch) => {
    response
      .then(({ data }) => {
        dispatch({ type: ACTION_LOGOUT, payload: false });
      })
      .catch((error) => {
        // nothing to do
        dispatch({ type: ACTION_LOGOUT, payload: false });
      });
  };
}

export function teacherClassList(session, callback) {
  var filter = encodeURI(`(createdby=${session?.userid})`);
  var url = `${INSTANCE_URL}api/v2/memoryquiz/_table/classprograms?include_count=true&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: TEACHER_CLASS_LISTS,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({
          status: 1,
          data: response.resource,
          count: response.meta.count,
        });
      },
      (error) => {}
    );
  };
}

export function teacherStudentsList(session, callback) {
  var filter = encodeURI(`(invitedby=${session?.userid})AND(usertype=student)`);
  var url = `${INSTANCE_URL}api/v2/memoryquiz/_table/users?include_count=true&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: TEACHER_STUDENT_LISTS,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({
          status: 1,
          data: response.resource,
          count: response.meta.count,
        });
      },
      (error) => {}
    );
  };
}

export function fetchAllStudentsList(session, callback) {
  var filter = encodeURI(`(usertype=student)`);
  var url = `${INSTANCE_URL}api/v2/memoryquiz/_table/users?include_count=true&filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: ALL_STUDENT_LISTS,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({
          status: 1,
          data: response.resource,
          count: response.meta.count,
        });
      },
      (error) => {}
    );
  };
}

export function fetchAllClassAndChapterList(session, callback) {
  var order = `order=createdon%20DESC`;
  var filter = encodeURI(`(createdby=${session?.userid})`);
  var url = `${INSTANCE_URL}api/v2/memoryquiz/_table/classprograms?related=programchapters_by_classidfk&include_count=true&filter=(${filter})&${order}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: ALL_CLASS_WITH_CHAPTER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({
          status: 1,
          data: response.resource,
          count: response.meta.count,
        });
      },
      (error) => {}
    );
  };
}

export function clearAllClassAndChapterAndSetList() {
  return (dispatch) => {
    dispatch({
      type: ALL_CLASS_WITH_CHAPTER_AND_SET_LIST,
      payload: {},
    });
  };
}

export function fetchAllClassAndChapterAndSetList(session, callback) {
  var order = `order=createdon%20DESC`;
  var filter = encodeURI(`(createdby=${session?.userid})`);
  var url = `${INSTANCE_URL}api/v2/memoryquiz/_table/classprograms?related=programchapters_by_classidfk,questionsets_by_classidfk&include_count=true&filter=(${filter})&${order}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: ALL_CLASS_WITH_CHAPTER_AND_SET_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({
          status: 1,
          data: response.resource,
          count: response.meta.count,
        });
      },
      (error) => {}
    );
  };
}

export function validateEmailForAppUser(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/tikwash/_table/appuser?filter=(email=${values.email})`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        if (data.resource.length > 0) {
          callback({
            success: 2,
            message: "Email not available!",
          });
        } else {
          callback({ success: 1, message: "Email is available!" });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function addAppUser(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/tikwash/_table/appuser`;
  //values.usertype = "company";

  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var data = {
    resource: [{ ...values }],
  };

  var response = axios.post(url, data, config);

  return (dispatch) => {
    response
      .then(({ data }) => {
        //console.log("login data :- ", data);

        session = {
          ...session,
          session_token: data?.resource[0]?.session_token,
          userid: data?.resource[0]?.userid,
          dfid: data?.resource[0]?.userid,
          username: data?.resource[0]?.name,
          email: data?.resource[0]?.email,
          usertype: data?.resource[0]?.usertype,
        };

        dispatch({ type: ACTION_LOGIN, payload: true });
        dispatch({ type: SESSION_TOKEN, payload: session });

        session.sessionToken = data?.resource[0]?.session_token;
        setTimeout(() => {
          callback({
            success: 1,
            session: session,
            userid: data?.resource[0]?.userid,
          });
        }, 1000);
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function updateSession(session) {
  return (dispatch) => {
    dispatch({ type: SESSION_TOKEN, payload: session });
  };
}

export function initiateReset(values, callback) {
  //This function is used To initiate Reset
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var data = {
    email: values.email,
  };

  var url = `${INSTANCE_URL}/api/v2/user/password?reset=true`;
  var response = axios.post(url, data, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        callback({ success: 1, message: "Success" });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function setLocaleLanguage(lang) {
  // LocaleStrings.setLanguage(lang);
  return { type: LOCALE_LANGUAGE, payload: lang };
}

export function updateCompanybySeocode(session, seocode, callback) {
  var url = `${INSTANCE_URL}/api/v2/tikwash_script/`;
  var body = {
    session: session,
    seocode: seocode,
    type: "updatebyseocode",
  };
  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        if (response.result == "success") {
          callback({ success: 1 });
        } else {
          callback({ success: 0 });
        }
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function initiateResetCustom(values, callback) {
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  var params = {
    email: values.email,
    type: "initiateReset",
  };

  var url = `${INSTANCE_URL}/api/v2/password_reset_script`;
  var response = axios.post(url, params, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        if (data.success) {
          callback({ success: true, message: "Success" });
        } else {
          callback({ success: false, message: data.desc });
        }
      })
      .catch((error) => {
        callback({ success: false, message: error });
      });
  };
}

export function resetPassword(values, callback) {
  var config = {
    headers: {
      contentType: "application/json; charset=utf-8",
      "X-DreamFactory-Api-Key": APP_API_KEY,
    },
  };

  values.type = "reset";

  var url = `${INSTANCE_URL}/api/v2/password_reset_script`;
  var response = axios.post(url, values, config);
  return (dispatch) => {
    response
      .then(({ data }) => {
        if (data.success) {
          callback({ success: true, message: "Success" });
        } else {
          callback({ success: false, message: data.desc });
        }
      })
      .catch((error) => {
        callback({ success: false, message: error });
      });
  };
}
